import isNil from 'lodash.isnil'

export default {
  methods: {
    goToFirstError() {
      const firstElementError = document.getElementsByClassName('input__error')
      if (isNil(firstElementError) || firstElementError.length === 0) {
        return
      }

      const errorParent = firstElementError[0].parentNode
      const inputError = errorParent.querySelector('.input__line')
      const selectError = errorParent.querySelector('.multiselect__input')
      const element = inputError === null ? selectError : inputError

      if (element === null) {
        return
      }

      element.focus()
      element.click()
      this.scrollTo(element)
    }
  }
}
